module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0006.jpg?v=dcaf85e8";